module.exports = __webpack_public_path__ + "img/coffee-web.d1f66e3f.webp";